export default {
  meta: {
    title: '添加网规申请流程',
    url: '/networkplan/index', // 埋点字段，上报归属的模块
    urlName: '网规管理' // 埋点字段，上报归属的模块
  }
};
